import type { DealCatalog } from "../../deal-protocol/src";
import { candidateThemeBundle } from "./candidate-theme-selection";

export const OUTDOOR_SPORTS_CANDIDATE_CATALOG_REVISION =
  "catalog.outdoor-sports.candidate-4";

export const outdoorSportsCandidateTheme = candidateThemeBundle("outdoor").theme;

export const outdoorSportsCandidateCatalog: DealCatalog = {
  catalogRevision: OUTDOOR_SPORTS_CANDIDATE_CATALOG_REVISION,
  themes: [outdoorSportsCandidateTheme]
};
